module.exports = __webpack_public_path__ + "img/marker_three_red1.032d9b9b.png";